import React from 'react';
import PropTypes from 'prop-types';

import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

import { withStyles } from '@material-ui/core/styles';
import Caret from '../../../../../assets/images/icons/caret.svg';
import NoSsr from '@material-ui/core/NoSsr';

import formStyles from '../../styles/styles.module.scss';
import styles from './styles/styles.module.scss';

/*

MuiInputBase-root MuiOutlinedInput-root  MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-adornedEnd MuiOutlinedInput-adornedEnd

*/

const StyledAutocomplete = withStyles({
  option: {
    color: '#414141',
    fontSize: '16px',
    fontFamily: 'Proxima Nova, Arial, sans-serif !important',
    '&[data-focus="true"]': {
      background: '#f2f2f2'
    }
  },
  root: {
    display: 'flex',
    width: '100%',
    height: '48px',
    borderRadius: '16px',
    fontFamily: 'Proxima Nova, Arial, sans-serif !important',
    '& .MuiOutlinedInput-input': {
      fontFamily: 'Proxima Nova, Arial, sans-serif !important',
      padding: '10px 16px',
      margin: '7px 0px',
      borderRadius: '8px',
      color: '#414141'
    },
    '& .MuiFormLabel-root.MuiFormLabel-filled': {
      marginTop: '4px'
    },
    '& .MuiFormLabel-root': {
      fontFamily: 'Proxima Nova, Arial, sans-serif !important',
      lineHeight: '8px'
    },
    '& .MuiInputLabel-outlined': {
      color: '#b2aea7'
    },
    '& .MuiAutocomplete-endAdornment': {
      // display: 'none'
    },
    '& .MuiAutocomplete-clearIndicator': {
      display: 'none'
    },
    '& .MuiAutocomplete-popupIndicator': {
      background: 'none'
    },
    '& .MuiIconButton-root:hover': {
      background: 'none'
    },
    '& input + fieldset': {
      borderRadius: '8px',
      color: '#767676',
      borderColor: '#e6e6e6'
    },
    '& input:valid:focus + fieldset': {
      borderLeftWidth: '2 !important',
      borderWidth: '2',
      borderColor: '#428A13 !important',
      color: '#428A13'
    },
    '& input:focus + fieldset': {
      color: '#428A13',
      borderColor: '#428A13 !important'
    },
    '&. .MuiFormHelperText-contained': {
      margin: '4px 14px'
    },
    '& .MuiFormLabel-root.Mui-error': {
      color: 'red !important'
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      padding: '0px 0px 0px 8px',
      height: '48px',
      minHeight: '48px !important' // mobile safari
    },
    '& .MuiAutocomplete-inputRoot': {
      fontFamily: 'Proxima Nova, Arial, sans-serif !important'
    },
    '& :hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#428A13 !important'
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      color: '#428A13 !important',
      borderColor: '#428A13 !important'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#428A13'
    },
    '& .MuiFormLabel-root.Mui-focused.Mui-error': {
      color: 'red'
    },
    '& .MuiFormHelperText-root': {
      color: 'red !important'
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: 'red !important',
      borderWidth: '2px',
      color: 'red !important'
    }
  }
})(Autocomplete);

const SsrStyledTextField = ({ label }) => {
  return <div className={styles.ssrContainer}>{label}</div>;
};

const OutlinedAutocomplete = ({ changeHandler, enterKeyHandler, options, name, autocomplete, value, label, isError, errorMessage }) => {
  const onKeyPress = event => {
    if (event.key === 'Enter') {
      enterKeyHandler();
    }
  };

  return (
    <div className={`${styles.container} ${isError ? formStyles.inputError : ''}`}>
      <NoSsr fallback={<SsrStyledTextField label={label} />}>
        <StyledAutocomplete
          autoComplete
          autoSelect
          autoHighlight
          name={name}
          options={options}
          value={value}
          popupIcon={<img src={Caret} />}
          onChange={(event, value) => changeHandler({ target: { name, value } })}
          getOptionLabel={option => (option ? option.title : '')}
          getOptionSelected={(option, value) => option.value === value.value}
          renderInput={params => (
            <TextField
              {...params}
              name={name}
              autoComplete={autocomplete}
              onKeyPress={onKeyPress}
              label={label}
              variant="outlined"
              fullWidth
              error={isError}
              helperText={isError ? errorMessage : ''}
            />
          )}
        />
      </NoSsr>
    </div>
  );
};

OutlinedAutocomplete.defaultProps = {
  changeHandler: () => {},
  value: '',
  label: '',
  isError: false,
  errorMessage: ''
};

OutlinedAutocomplete.propTypes = {
  changeHandler: PropTypes.func,
  value: PropTypes.string,
  label: PropTypes.string,
  isError: PropTypes.bool,
  errorMessage: PropTypes.string
};

export default OutlinedAutocomplete;
